import { formatToBRL } from '@cannect/utils/formatters'
import { formatApiDate, getSubscriptionDisplayState } from '@cannect/services/resources/recurrency/helpers'
import type { SubscriptionDetail } from '@cannect/services/resources/recurrency/types'
import { StatusChip } from '../components/StatusChip'
import { subscriptionsCopy } from '../copy'

const copy = subscriptionsCopy.header

// Cabeçalho do detalhe. Valores exatamente como o serviço manda (FR-013): o
// portal não soma itens nem calcula desconto; os preços dos itens já vêm com
// o desconto de assinante.
export const DetailHeader = ({ detail }: { detail: SubscriptionDetail }) => {
  const state = getSubscriptionDisplayState(detail)
  const open = detail.status === 'active' || detail.status === 'paused'
  const cycleLocked = detail.status === 'active' && !detail.canEdit

  return (
    <section
      aria-label="Resumo da assinatura"
      className="flex flex-col gap-4 rounded-xl border border-solid border-neutral-100 bg-white p-4 md:p-6">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-base font-semibold text-neutral-800">{state.sentence}</p>
        <StatusChip state={state} />
      </div>

      {open && (
        <dl className="grid grid-cols-1 gap-x-6 gap-y-2 text-sm sm:grid-cols-2">
          <div className="flex justify-between gap-2 sm:flex-col sm:justify-start">
            <dt className="text-neutral-600">{copy.nextCharge}</dt>
            <dd className="font-semibold text-neutral-800">{formatApiDate(detail.nextChargeAt) || '—'}</dd>
          </div>
          <div className="flex justify-between gap-2 sm:flex-col sm:justify-start">
            <dt className="text-neutral-600">Intervalo</dt>
            <dd className="text-neutral-800">{subscriptionsCopy.cycleEvery(detail.cycleDays)}</dd>
          </div>
          <div className="flex justify-between gap-2 sm:flex-col sm:justify-start">
            <dt className="text-neutral-600">{copy.shipping}</dt>
            <dd className="text-neutral-800">
              {detail.estimatedShipping !== null && detail.estimatedShipping !== undefined
                ? formatToBRL(detail.estimatedShipping)
                : copy.shippingUnknown}
            </dd>
          </div>
          <div className="flex justify-between gap-2 sm:flex-col sm:justify-start">
            <dt className="text-neutral-600">{copy.total}</dt>
            <dd className="text-lg font-semibold text-neutral-800">
              {detail.estimatedAmount !== null && detail.estimatedAmount !== undefined
                ? formatToBRL(detail.estimatedAmount)
                : '—'}
            </dd>
          </div>
        </dl>
      )}

      {open && <p className="text-xs text-neutral-600">{copy.discountNote}</p>}

      {detail.status === 'active' && detail.canEdit && detail.editLockAt && (
        <p className="text-sm text-neutral-700">{copy.editUntil(formatApiDate(detail.editLockAt))}</p>
      )}

      {cycleLocked && (
        <p role="note" className="rounded-md bg-warning-100 px-3 py-2 text-sm text-neutral-800">
          {copy.cycleLocked}
        </p>
      )}
    </section>
  )
}
